import { baseUrl, headers, jwtHeaders, logoutUtil } from "../common/data";

export const fetchAllRequest = async (queryParams) => {
    const response = await fetch(`${baseUrl}/api/branch/getallbranches${queryParams?queryParams:''}`, {
        method: "GET",
        headers,
        redirect: "follow",
    });
   
    const resData = await response?.json();
    return resData;
};